import { api } from "../utils/api";

export const Check = async () => {
  // console.log("Check");

  const response = await api.get("/version");

  return response.data;
};
